import React, { Component } from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import Typography from '../Typography';

class ScheduleTabs extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    selectedTab: PropTypes.number.isRequired,
    onTabClick: PropTypes.func.isRequired,
    styles: PropTypes.object,
    tabs: PropTypes.array,
  };

  static defaultProps = {
    styles: null,
    tabs: [],
  };

  constructor(props) {
    super(props);
    this.state = {
      tabWidth: this.getTabWidth(),
    };
  }

  componentWillReceiveProps(newProps) {
    if (newProps.tabs && this.props.tabs) {
      if (newProps.tabs.lenght !== this.props.tabs.lenght) {
        this.setState({
          tabWidth: this.getTabWidth(),
        });
      }
    }
  }

  componentDidMount() {
    this.setScrollPosition();
  }

  getTabWidth = () => this.props.tabs && `${100 / this.props.tabs.lenght}%`;

  getMarkerStyle = () => {
    const { selectedTab, styles } = this.props;
    const backgroundColor = styles.colors.text.color;
    return {
      transform: `translate(${100 * selectedTab}%,0)`,
      backgroundColor: (styles && styles.tabs && styles.tabs.color) || backgroundColor,
    };
  };

  getTabProps = index => {
    const { styles } = this.props;
    const tabProps = {
      style: {
        ...styles.colors.text,
        ...styles.unselected,
        width: this.state.tabWidth,
      },
      onClick: () => {
        this.props.onTabClick(index);
      },
      role: 'tab',
      tabIndex: 1,
    };
    if (index === this.props.selectedTab) {
      return { ...tabProps, ...this.getSelectedTabProps() };
    }
    return tabProps;
  };

  getSelectedTabProps = index => {
    const { classes, styles } = this.props;
    return {
      style: {
        ...styles.colors.text,
        ...(styles && styles.tabs),
        width: this.state.tabWidth,
      },
      className: classes.tabSelected,
      ref: element => {
        this.selectedElement = element;
      },
      onClick: () => {},
      role: null,
      tabIndex: null,
    };
  };

  setScrollPosition = () => {
    if (this.selectedElement) {
      this.rootElement.scrollLeft =
        this.selectedElement.offsetLeft - this.rootElement.clientWidth / 2;
    }
  };

  render() {
    const { classes, tabs, styles } = this.props;
    if (!tabs || tabs.length < 2) {
      return null;
    }

    return (
      <div
        className={classes.root}
        ref={element => {
          this.rootElement = element;
        }}
      >
        <ul style={styles.unselected}>
          {tabs.map((tab, i) => (
            <li key={i} {...this.getTabProps(i)}>
              <Typography component="p">{tab}</Typography>
              {i === 0 && <span style={this.getMarkerStyle()} />}
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

const stylesheet = theme => ({
  '@keyframes fade-in': {
    '0%': {
      opacity: 0,
      transform: `translate(0,-10px)`,
    },
    '100%': {
      opacity: 1,
      transform: `translate(0,0)`,
    },
  },
  root: {
    width: '100%',
    marginBottom: 8 * theme.spacing.unit,
    animation: 'fade-in 0.75s ease-out',
    WebkitOverflowScrolling: 'touch',
    overflowY: 'auto',
    overflowX: 'scroll',
    MsOverflowStyle: '-ms-autohiding-scrollbar',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    [theme.breakpoints.down('sm')]: {
      marginBottom: 3 * theme.spacing.unit,
    },
    '& ul': {
      borderBottom: '2px solid',
      marginBottom: 1,
      minWidth: '100%',
      display: 'inline-flex',
      justifyContent: 'center',
      listStyleType: 'none',
      padding: 0,
      margin: 0,
    },
    '& li': {
      flex: '1 0 auto',
      display: 'inline-block',
      minWidth: 96 + 4 * theme.spacing.unit,
      padding: 2 * theme.spacing.unit,
      boxSizing: 'border-box',
      maxWidth: 300,
      willChange: 'background-color',
      transition: `background-color ${theme.transitions.duration.shortest}ms`,
      color: '#666',
      position: 'relative',
      cursor: 'pointer',
      outline: 'none',
      WebkitTapHighlightColor: 'rgba(225,225,225,0.25)',
      [theme.breakpoints.down('sm')]: {
        minWidth: 80 + 4 * theme.spacing.unit,
      },
      '&:hover': {
        backgroundColor: 'rgba(240,240,240,0.75)',
        color: '#333',
      },
      '&:active': {
        backgroundColor: 'rgba(225,225,225,0.75)',
        color: '#333',
      },
    },
    '& p': {
      color: 'inherit',
      fontSize: 24,
      lineHeight: 1,
      textAlign: 'center',
      willChange: 'color',
      transition: `color ${theme.transitions.duration.shortest}ms`,
      [theme.breakpoints.down('sm')]: {
        fontSize: 20,
      },
    },
    '& span': {
      width: '100%',
      height: 4,
      position: 'absolute',
      bottom: -3,
      left: 0,
      backgroundColor: theme.palette.common.lightBlack,
      zIndex: 1,
      borderRadius: 1,
      willChange: 'transform',
      transition: `transform ${theme.transitions.duration.shorter}ms`,
      transform: 'translate(0,0)',
    },
  },
  tabSelected: {
    'li&': {
      color: theme.palette.common.lightBlack,
      cursor: 'default',
      '&:hover': {
        backgroundColor: 'transparent',
        color: theme.palette.common.lightBlack,
      },
      '&:active': {
        backgroundColor: 'transparent',
        color: theme.palette.common.lightBlack,
      },
    },
  },
});

export default injectSheet(stylesheet)(ScheduleTabs);



// WEBPACK FOOTER //
// ./src/site-render/src/ScheduleSection/ScheduleTabs.js